<template>
  <model-table
    title="Station Types"
    :collection="registerTypes"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { name: 'registerPages', label: 'Pages', field: registerType => $_.map(registerType.registerPages.data, 'displayName'), component: 'chips' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
  >
    <register-type-form />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import RegisterTypeForm from 'src/modules/admin/register-type/RegisterTypeForm'

export default {
  name: 'RegisterTypeTable',
  components: {
    ModelTable,
    RegisterTypeForm
  },
  data () {
    return {
    }
  },
  configuration: ['registerTypes']
}
</script>
